import { type MotifComponent, type MotifComponentProps, m } from '../../motif';
import { footnoteVars } from './FootnoteBlock.palette';

export const snapFootnoteBlockPrimaryVars: MotifComponentProps<MotifComponent.FOOTNOTE> = {
  ...footnoteVars,
  '--footnote-border-color': m('--neutral-v700'),
} as const;
